var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileBuilderFinancial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-bag_2_",
    "data-name": "money-bag (2)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55671",
    "data-name": "Path 55671",
    d: "M109.043,11.41h8.984a1.357,1.357,0,0,0,1.085-.548,14.129,14.129,0,0,0,2.958-8.616v-.9A1.348,1.348,0,0,0,120.723,0c-2.5,0-5.751,1.616-7.188,2.4C112.1,1.616,108.844,0,106.348,0A1.348,1.348,0,0,0,105,1.348v.9a14.129,14.129,0,0,0,2.958,8.616A1.357,1.357,0,0,0,109.043,11.41Z",
    transform: "translate(-95.566)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55672",
    "data-name": "Path 55672",
    d: "M211.612,347.47v3.816a2.416,2.416,0,0,0,1.207-1.708A1.821,1.821,0,0,0,211.612,347.47Z",
    transform: "translate(-192.6 -316.252)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55673",
    "data-name": "Path 55673",
    d: "M178.753,282.264a1.228,1.228,0,0,0,.31,1.19,4.236,4.236,0,0,0,.368.255v-2.537A1.738,1.738,0,0,0,178.753,282.264Z",
    transform: "translate(-162.664 -255.91)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55674",
    "data-name": "Path 55674",
    d: "M25.336,176.885V170.2a3.778,3.778,0,0,1,3.194-3.739,3.125,3.125,0,0,0,2.248-1.6,66.357,66.357,0,0,0-6.457-7.452,1.347,1.347,0,0,0-.962-.4H12.578a1.348,1.348,0,0,0-.962.4C5.872,163.256,0,170.347,0,178.563v.1a10.349,10.349,0,0,0,10.4,10.235H25.533a10.458,10.458,0,0,0,4.475-1A15.292,15.292,0,0,1,25.336,176.885Zm-2.9-.293a4.69,4.69,0,0,1-1.444,2.664,4.475,4.475,0,0,1-1.977,1.06v.851a1.123,1.123,0,0,1-2.246,0v-.746a5.561,5.561,0,0,1-2.816-1.046,1.123,1.123,0,1,1,1.23-1.88,3.53,3.53,0,0,0,1.587.666v-4.934a8.523,8.523,0,0,1-1.754-1.023,3.425,3.425,0,0,1-1.131-3.373,3.859,3.859,0,0,1,2.646-3.026q.12-.036.238-.067V165a1.123,1.123,0,0,1,2.246,0v.619a3.986,3.986,0,0,1,2.306,1.181,1.123,1.123,0,0,1-1.688,1.482,1.649,1.649,0,0,0-.618-.357v3.8c.212.079.424.155.632.229a4.055,4.055,0,0,1,2.789,4.642Z",
    transform: "translate(0 -142.895)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55675",
    "data-name": "Path 55675",
    d: "M329.04,256.255a5.815,5.815,0,0,1-4.275-3.147.68.68,0,0,0-.61-.372h-6.339a.68.68,0,0,0-.61.372,5.815,5.815,0,0,1-4.275,3.147,1.1,1.1,0,0,0-.929,1.079v6.686a12.607,12.607,0,0,0,8.557,11.939,1.332,1.332,0,0,0,.854,0,12.607,12.607,0,0,0,8.557-11.939v-6.686A1.1,1.1,0,0,0,329.04,256.255Zm-3.291,6.572-5.082,5.082a1.347,1.347,0,0,1-1.906,0l-2.541-2.541a1.348,1.348,0,0,1,1.906-1.906l1.588,1.588,4.129-4.129a1.348,1.348,0,1,1,1.906,1.906Z",
    transform: "translate(-283.969 -230.029)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBuilderFinancial);
export default __webpack_public_path__ + "static/media/profile-builder-financial.c8c673b661fd5952acc873bf62f96370.svg";
export { ForwardRef as ReactComponent };